import React from "react";
import { Route, Link } from "react-router-dom";
import { Layout, Menu } from "antd";
import Nav from "@/components/Nav";
import { getQueryString } from '@/utils/tools';

import DomainSetting from "@/components/TaobaoDomainChange/DomainSetting";
import DomainOverview from "@/components/TaobaoDomainChange/DomianOverview";

import "./style.less";

const { Sider, Content } = Layout;
const clsPrefix = "taobaoDomainChange";

const siteId = getQueryString('site_id');
 
const getSelectedKeyByRoute = () => {
  let currentRoute = window.location.pathname;

  let selectedKey = null;
  switch (currentRoute) {
    case `/v5/tkPlugin`:
      selectedKey = ["1"];
      break;

    case `/v5/tkPlugin/setting`:
      selectedKey = ["2"];
      break;

    default:
      selectedKey = ["1"];
      break;
  }
  return selectedKey;
};

const TaobaoDomainChange = ({ match }) => (
  <React.Fragment>
    <Nav />
    <Layout style={{ maxHeight: "0" }}>
      <Sider className={`${clsPrefix}-sider`} theme='light'>
        <Menu
          theme='light'
          mode='inline'
          defaultSelectedKeys={getSelectedKeyByRoute()}
        >
          <Menu.Item key='1'>
            <Link
              to={{
                pathname: "/v5/tkPlugin",
                search: `?site_id=${siteId}`
              }}
            >
              概况
            </Link>
          </Menu.Item>
          <Menu.Item key='2'>
            <Link
              to={{
                pathname: "/v5/tkPlugin/setting",
                search: `?site_id=${siteId}`
              }}
            >
              设置
            </Link>
          </Menu.Item>
        </Menu>
      </Sider>
      <Content className={`${clsPrefix}-content`}>
        <TaobaoDomainChangePage match={match} />
      </Content>
    </Layout>
  </React.Fragment>
);

const TaobaoDomainChangePage = ({ match }) => {
  return (
    <div>
      <Route exact path={`${match.url}`} component={DomainOverview} />
      <Route path={`${match.url}/setting`} component={DomainSetting} />
    </div>
  );
};

export default TaobaoDomainChange;
